import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { ViewDataWithSection } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { getMultiSectionFigmaLayout } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';
import {
  PRODUCT_SUBTITLE_HEIGHT,
  PRODUCT_SUBTITLE_MARGIN_TOP,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/shelfDisplay.figma';

export function getMarginUnderHero(viewData: ViewDataWithSection) {
  if (!viewData.section.products?.length)
    // If no products do not add gap
    return getGap({
      width: viewData.columnWidth!,
      height: 0,
    });

  const marginBottom =
    getMultiSectionFigmaLayout(viewData) === 'full'
      ? PRODUCT_SUBTITLE_HEIGHT + PRODUCT_SUBTITLE_MARGIN_TOP * 2 + 5 // A GOD KNOWS WHY THIS IS NEEDED TO MAKE THE HERO COLUMNS EVEN WITH THE REST
      : PRODUCT_SUBTITLE_MARGIN_TOP * 2;

  return getGap({
    width: viewData.columnWidth!,
    height: marginBottom,
  });
}
